export const natijehDaaviMaliOptions = [
  "سایر موارد",
  "قرار ابطال دادخواست پیش از پاسخ به دعوا و دفاع از آن",
  "قرار رد دادخواست پس از پاسخ به دعوا و دفاع از آن",
  "قرار عدم استماع یا رد دعوی به عللی مانند مرور زمان و اعتبار امر مختومه و رد تقاضای اعاده دادرسی",
  "قرار سقوط دعوای تجدیدنظر پیش از پاسخ به دعوا و دفاع از آن",
  "قرار سقوط دعوای تجدیدنظر پس از پاسخ به دعوا و دفاع از آن",
];
export const noeDaaviGheyrMaliOptions = [
  "مطلق دعاوی خانوادگی یا دعاوی ناشی از زوجیت و همچنین امور حسبی",
  "دعاوی که خواسته آن ها مالی نیست یا تعیین بهای خواسته به موجب قانون لازم نیست",
];
export const salahiatKeyfariOptions = [
  "جرایم داخل در صلاحیت رسیدگی دادگاه های کیفری یک, نظامی یک و دادگاه انقلاب",
  "جرایم داخل در صلاحیت رسیدگی دادگاه های کیفری دو, نظامی دو و و اطفال و نوجوانان",
  "دعاوی که فقط وکلای تبصره 48 قانون آیین دادرسی می توانند در آنها قبول وکالت کنند",
];
export const mojazatKeyfariOptions = [
  "جرایم مستوجب مجازات های سلب حیات, قطع عضو, حبس ابد یا حبس تعضیری درجه یک",
  "جرایم مستوجب مجازات های تعزیری درجه 2 و 3",
  "دیگر جرایم",
];
